/**
 * Tags a create body with the entity a clone was made from, so the server copies
 * that entity's files onto the new one. `excludeFileIds` are the source files the
 * user dropped in the drawer before saving.
 */
export const withCopyFilesFrom = <T extends object>(
  entity: T,
  copyFilesFromId: string,
  excludeFileIds: string[] = [],
): T & { copyFilesFromId: string; excludeFileIds: string[] } => {
  const serialized =
    'toJSON' in entity && typeof entity.toJSON === 'function'
      ? (entity.toJSON() as Record<string, unknown>)
      : { ...entity };

  return { ...serialized, copyFilesFromId, excludeFileIds } as T & {
    copyFilesFromId: string;
    excludeFileIds: string[];
  };
};
